"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVenueAutoCheckInReminderAt = exports.getVenueAutoCheckInLocationCheckAt = exports.getVenueAutoCheckInArmAt = exports.getIsoWeekdayOfDate = exports.isValidIsoWeekday = exports.VENUE_AUTO_CHECK_IN_FLEXIBLE_SLOT_REMINDER_HOUR = exports.VENUE_AUTO_CHECK_IN_ARM_RADIUS_METERS = exports.VENUE_AUTO_CHECK_IN_AWAY_DISTANCE_METERS = exports.VENUE_AUTO_CHECK_IN_REMINDER_DELAY_MINUTES = exports.VENUE_AUTO_CHECK_IN_MAX_DAYS_AHEAD = exports.VENUE_AUTO_CHECK_IN_LOCATION_CHECK_DELAY_MINUTES = exports.VENUE_AUTO_CHECK_IN_ARM_LEAD_MINUTES = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
const enums_1 = require("../enums");
const venue_visit_plan_time_slot_1 = require("./venue-visit-plan-time-slot");
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
/**
 * Per-plan timeline, relative to the slot start (concrete slots) or to the flexible-slot reminder
 * hour (`NotSure`/`AllDay`, whose nominal 00:00 start isn't a real arrival time):
 *   arm (−45 / −60 min) → location check (+15 / −15 min) → reminder (+30 / ±0 min).
 */
exports.VENUE_AUTO_CHECK_IN_ARM_LEAD_MINUTES = 45;
/** Silent location check, if there's been no check-in in the slot yet. */
exports.VENUE_AUTO_CHECK_IN_LOCATION_CHECK_DELAY_MINUTES = 15;
/**
 * How far ahead (days, inclusive) auto check-in plans are generated — one more than the manual
 * booking window (VENUE_VISIT_PLAN_MAX_DAYS_AHEAD), so every weekday's next occurrence always
 * has a plan: with only 7 days (today + 6), a weekday whose slot already passed today would have
 * none until tomorrow's generation run.
 */
exports.VENUE_AUTO_CHECK_IN_MAX_DAYS_AHEAD = 7;
/** How long into a concrete slot the user gets before the "you're not there yet" reminder. */
exports.VENUE_AUTO_CHECK_IN_REMINDER_DELAY_MINUTES = 30;
/** Further than this from the venue (40 miles) during the slot → treated as away, no reminder. */
exports.VENUE_AUTO_CHECK_IN_AWAY_DISTANCE_METERS = 64374;
/** The client only arms geofences for auto check-in venues within this distance (40 miles). */
exports.VENUE_AUTO_CHECK_IN_ARM_RADIUS_METERS = 64374;
/**
 * Local hour the reminder goes out for the flexible `NotSure`/`AllDay` slots, whose nominal
 * window (00:00 → 24:00) has no meaningful "start + delay" moment.
 */
exports.VENUE_AUTO_CHECK_IN_FLEXIBLE_SLOT_REMINDER_HOUR = 12;
const isValidIsoWeekday = value => typeof value === 'number' && Number.isInteger(value) && value >= 1 && value <= 7;
exports.isValidIsoWeekday = isValidIsoWeekday;
/** ISO weekday (1 = Monday … 7 = Sunday) of a YYYY-MM-DD calendar date. */
const getIsoWeekdayOfDate = plannedDate => {
  const day = (0, dayjs_1.default)(plannedDate, 'YYYY-MM-DD').day();
  return day === 0 ? 7 : day;
};
exports.getIsoWeekdayOfDate = getIsoWeekdayOfDate;
const isFlexibleSlot = timeSlot => timeSlot === enums_1.VenueVisitPlanTimeSlot.NotSure || timeSlot === enums_1.VenueVisitPlanTimeSlot.AllDay;
/** When the "wake up and arm the geofence" silent push for a plan on `plannedDate` is due. */
const getVenueAutoCheckInArmAt = (timeSlot, plannedDate, tz) => {
  if (isFlexibleSlot(timeSlot)) {
    return (0, exports.getVenueAutoCheckInReminderAt)(timeSlot, plannedDate, tz).subtract(60, 'minute');
  }
  const {
    start
  } = (0, venue_visit_plan_time_slot_1.getVenueVisitPlanTimeSlotBounds)(timeSlot, plannedDate, tz !== null && tz !== void 0 ? tz : (0, venue_visit_plan_time_slot_1.getServerTimezone)());
  return start.subtract(exports.VENUE_AUTO_CHECK_IN_ARM_LEAD_MINUTES, 'minute');
};
exports.getVenueAutoCheckInArmAt = getVenueAutoCheckInArmAt;
/** When the silent location check for a plan on `plannedDate` is due (if not checked in by then). */
const getVenueAutoCheckInLocationCheckAt = (timeSlot, plannedDate, tz) => (0, exports.getVenueAutoCheckInReminderAt)(timeSlot, plannedDate, tz).subtract(exports.VENUE_AUTO_CHECK_IN_REMINDER_DELAY_MINUTES - exports.VENUE_AUTO_CHECK_IN_LOCATION_CHECK_DELAY_MINUTES, 'minute');
exports.getVenueAutoCheckInLocationCheckAt = getVenueAutoCheckInLocationCheckAt;
/** When the reminder for an auto check-in plan on `plannedDate` becomes due. */
const getVenueAutoCheckInReminderAt = (timeSlot, plannedDate, tz) => {
  const timezone = tz !== null && tz !== void 0 ? tz : (0, venue_visit_plan_time_slot_1.getServerTimezone)();
  if (isFlexibleSlot(timeSlot)) {
    return dayjs_1.default.tz(plannedDate, timezone).hour(exports.VENUE_AUTO_CHECK_IN_FLEXIBLE_SLOT_REMINDER_HOUR).minute(0).second(0).millisecond(0);
  }
  const {
    start
  } = (0, venue_visit_plan_time_slot_1.getVenueVisitPlanTimeSlotBounds)(timeSlot, plannedDate, timezone);
  return start.add(exports.VENUE_AUTO_CHECK_IN_REMINDER_DELAY_MINUTES, 'minute');
};
exports.getVenueAutoCheckInReminderAt = getVenueAutoCheckInReminderAt;
//# sourceMappingURL=venue-auto-check-in.js.map